module.exports = __webpack_public_path__ + "assets/img/2.8c341d0c.png";